import SimpleBlockContent from '@components/bits/SimpleBlockContent';
import React, { FunctionComponent, useEffect, useState } from 'react';

import styles from './index.module.scss';
import ToolPreview from './ToolPreview';
import ToolsFilterBar from './ToolsFilterBar';
import ToolsPagination from './ToolsPagination';

const pageItemCount = 12;
type Props = {
  tools;
  desc;
};

const ToolsPlug: FunctionComponent<Props> = ({ tools: { toolsList }, desc }) => {
  const [pageIndex, setPageIndex] = useState(0);
  const [filters, setFilter] = useState({});
  const [filteredList, setFilteredList] = useState(toolsList);

  const toolTypes = {};

  toolsList.forEach((element) => {
    toolTypes[element.tool.category] = true;
  });

  const updateFilters = (filter): void => {
    if (filter === '') {
      setFilter({});
      return;
    }

    const tmpFilters = { ...filters };

    if (filters[filter]) {
      delete tmpFilters[filter];
    } else {
      tmpFilters[filter] = true;
    }

    setFilter(tmpFilters);
  };

  const updatePageIndex = (dir): void => {
    const maxPages = Math.floor(filteredList.length / pageItemCount);
    let newPageIndex = pageIndex + 1 * dir;

    if (newPageIndex < 0) newPageIndex = maxPages;
    if (newPageIndex > maxPages) newPageIndex = 0;

    setPageIndex(newPageIndex);
  };

  /* Update filtered array when adding or removing filters */
  useEffect(() => {
    const filtersArr = Object.keys(filters);

    if (!filtersArr.length) {
      setFilteredList(toolsList);
      return;
    }

    const nList = toolsList
      .map((x) => {
        const match = filtersArr.find((item) => {
          const check = item === x?.tool?.category;

          return check;
        });

        if (match) {
          return x;
        }
      })
      .filter((item) => item !== undefined); // Can also use filter(item => item);

    setFilteredList(nList);
  }, [filters]);

  /* Reset pagination when updating filters */
  useEffect(() => {
    updatePageIndex(0);
  }, [filteredList]);

  const startIndex = pageIndex * pageItemCount;
  const endIndex = Math.min(startIndex + pageItemCount, filteredList.length);
  const pageList = filteredList.slice(startIndex, endIndex);

  return (
    <div className={`article-content ${styles.root}`}>
      <div>
        <SimpleBlockContent data={desc} />
      </div>
      <div>
        <span className={styles['_toolbar']}>
          <ToolsFilterBar
            types={Object.keys(toolTypes)}
            totalItems={toolsList.length}
            updateFilters={updateFilters}
            activeFilters={filters}
          />
          <ToolsPagination
            startIndex={startIndex}
            endIndex={endIndex}
            itemTotal={Number(filteredList.length) || 0}
            setPageIndex={updatePageIndex}
          />
        </span>
        <div className={styles['_tools-wrapper']}>
          {pageList.map((val, key) => {
            return <ToolPreview key={key} {...val} />;
          })}
        </div>
      </div>
    </div>
  );
};

export default React.memo(ToolsPlug);
